export default "__VITE_ASSET__CoA75GeM__"